import { render } from "./WeMakeTitle.vue?vue&type=template&id=13a4be9c&scoped=true"
import script from "./WeMakeTitle.vue?vue&type=script&lang=js"
export * from "./WeMakeTitle.vue?vue&type=script&lang=js"

import "./WeMakeTitle.vue?vue&type=style&index=0&id=13a4be9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13a4be9c"]])

export default __exports__